precision highp float;

#include ./lib/snoise.glsl

uniform float uTime;
uniform vec2  uMouse;
uniform float uMouseStrength;
uniform float uScrollVel;
uniform float uProgress; // local hero scene progress

varying vec2  vUv;
varying float vElev;

void main() {
  vUv = uv;
  vec3 pos = position;

  // Layered noise + low-frequency topography
  float n = snoise(pos.xy * 0.4 + uTime * 0.15);
  float topo = sin(pos.x * 0.5 + uTime * 0.3) * cos(pos.y * 0.5 + uTime * 0.2);
  float elev = topo * 0.4 + n * 0.5;

  // Gaussian bump under the mouse — accent on interaction
  vec2 toMouse = uMouse - pos.xy;
  float d = length(toMouse);
  float gauss = exp(-d * d * 0.6) * uMouseStrength;
  elev += gauss * 0.6;

  // Scroll velocity boost — scrolling fast = more terrain agitation
  elev += uScrollVel * 0.05;

  // Progress-driven amplification — as the camera dollies in, terrain settles down
  elev *= mix(1.0, 0.55, uProgress);

  pos.z = elev * 0.35;
  vElev = elev;

  gl_Position = projectionMatrix * modelViewMatrix * vec4(pos, 1.0);
}
